import { ContainerModule } from 'inversify';
import { type Connection } from '@dealroadshow/socket-frontend-sdk';
import SocketDITypes from '@finsight/socket-client/DITypes';
import { PageRenderingState, PageRenderingStateValue } from '@framework/di';
import reconnectAfterSuspension from '@/creditflowresearch/infrastructure/socket/reconnectAfterSuspension';

// The connection class is shared with other tenants, so CFR adds its sleep handling when CFR's own container
// creates the connection. Only in the browser: the server never connects.
export const socketConnectionModule = new ContainerModule(({ onActivation }) => {
  onActivation<Connection>(SocketDITypes.SocketConnection, (context, connection) => {
    if (context.get(PageRenderingState) === PageRenderingStateValue.ClientSideRendering) {
      reconnectAfterSuspension(connection);
    }

    return connection;
  });
});

export default socketConnectionModule;
